import React, { useState, useEffect } from 'react';
import { Button, Input, Spinner as StrapSpinner } from 'reactstrap';
import { getDefaultAppFee, updateDefaultAppFee } from '../../../axios/appFee';
import { useAuthStore } from '../../../zustand-store/auth.store';
import Spinner from '../../../components/Common/Spinner';
import { toast } from 'react-toastify';

const DefaultSubscriptionPlan = () => {
  const [loader, setLoader] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const locationId = useAuthStore((state) => state.locationId);
  const [disabled, setDisabled] = useState(true);
  const [enableSubscriptionFee, setSubscriptionFee] = useState(false);
  const onLoad = async () => {
    setLoader(true);
    try {
      const data = await getDefaultAppFee();
      console.log(data, '==');

      if (data.status === 200 || data.status === 201) {
        const settings = data?.data?.data || [];

        const subsriptionPlanState = settings.find((s) => s.ARE_SUBSCRIPTIONS_ENABLED);

        setSubscriptionFee(
          subsriptionPlanState?.ARE_SUBSCRIPTIONS_ENABLED?.value == 'true' ? true : false
        );
      }
    } catch (err) {
      console.error('Failed to fetch default app fee:', err);
      toast.error('Failed to load default application fee settings.');
    }
    setLoader(false);
  };

  useEffect(() => {
    onLoad();
  }, [locationId]);

  const onSubmit = async () => {
    const confirmSubmit = window.confirm('Are you sure you want to save these changes?');
    if (!confirmSubmit) return; // stop if user cancels

    setSubmitting(true);
    try {
      const [enableFeeRes] = await Promise.allSettled([
        updateDefaultAppFee(
          5,
          'ARE_SUBSCRIPTIONS_ENABLED',
          enableSubscriptionFee == 1 ? true : false
        )
      ]);
      const enableFeeSuccess =
        enableFeeRes.status === 'fulfilled' &&
        (enableFeeRes.value.status === 200 || enableFeeRes.value.status === 201);

      if (enableFeeSuccess) {
        toast.success('Settings updated successfully');
        setDisabled(true);
        onLoad();
      } else {
        toast.error('Something went wrong while updating settings');
        if (!feeSuccess) console.error('Fee update error:', feeRes.reason);
        if (!unitSuccess) console.error('Unit update error:', unitRes.reason);
        if (!enableFeeSuccess) console.error('Enable fee update error:', enableFeeRes.reason);
      }
    } catch (error) {
      toast.error('Unexpected error occurred during update');
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      {loader && <Spinner setLoading={setLoader} />}
      <div className="d-flex flex-column gap-3 col-12 col-md-8">
        <div className="row align-items-center">
          <div className="col-6">
            <p className="m-0" style={{ color: '#495057', fontWeight: 700, fontSize: '13px' }}>
              Subscription Fee Setting
            </p>
            <p className="m-0 text-muted">
              When enabled, users will have the option to choose the Pro subscription plan.
              <p>
                When disabled, the application will display only the Free plan, and all features
                will remain available.
              </p>
            </p>
          </div>

          <div className="col-2 d-flex justify-content-end">
            <div className="form-check form-switch form-switch-lg">
              <input
                className="form-check-input"
                type="checkbox"
                checked={enableSubscriptionFee}
                onClick={(e) => {
                  const isChecked = e.target.checked;

                  setSubscriptionFee(isChecked ? 0 : 1);
                  setDisabled(false);
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center mt-5 gap-2">
          <Button className="bg-primary" onClick={onSubmit} disabled={disabled || submitting}>
            {submitting ? 'Saving Changes' : 'Save Changes'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DefaultSubscriptionPlan;
